import { SKELETON_VARIANTS } from "./constants";
import { BaseSkeletonProps } from "./types";

import "./styles.css";

const TEXT_LINE_HEIGHT = "var(--spacing-300)";
const LAST_LINE_WIDTH = "60%";

const BaseSkeleton = ({
  variant = SKELETON_VARIANTS.BLOCK,
  width = "100%",
  height = TEXT_LINE_HEIGHT,
  lines = 3,
  className,
}: BaseSkeletonProps) => {
  if (variant === SKELETON_VARIANTS.TEXT) {
    return (
      <div
        className={`flex flex-col gap-200 ${className ?? ""}`}
        style={{ width }}
        aria-hidden
      >
        {Array.from({ length: lines }, (_, index) => (
          <span
            key={index}
            className="base-skeleton"
            style={{
              width:
                index === lines - 1 && lines > 1 ? LAST_LINE_WIDTH : "100%",
              height,
            }}
          />
        ))}
      </div>
    );
  }

  return (
    <span
      className={`base-skeleton ${variant === SKELETON_VARIANTS.CIRCLE ? "base-skeleton-circle" : ""} ${className ?? ""}`}
      style={{ width, height }}
      aria-hidden
    />
  );
};

export default BaseSkeleton;
